import { AppLocale } from "src/localization/localization"
import { getLocaleOrThrow } from "src/localization/state"

export function localizeText<T>(allTexts: Record<AppLocale, T>) {
  const locale = getLocaleOrThrow()

  return allTexts[locale]
}
